import React, { useEffect, useState } from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import { GatsbyImage, StaticImage, getImage } from "gatsby-plugin-image"
import SearchBox from "./Search/SearchBox"
import MenuItem from "./Menu/MenuItem"

const Header = ({ siteTitle }) => {
  const [isExpanded, toggleExpansion] = useState(false)
  const [scrolled, setScrolled] = useState(false);
  
  const toggleMenu = () => {
    toggleExpansion((prev) => !prev)
  }
  
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const data = useStaticQuery(graphql`
    query {
      recipe: allWpRecipes(limit: 1, sort: {date: DESC}) {
                edges {
                  node {
                    featuredImage {
                      node {
                        gatsbyImage(height: 310, quality: 10, layout: CONSTRAINED, width: 275)
                      }
                    }
                    slug
                    title
                  }
                }
              }
    }
  `)

  const featured = {
    image: data?.recipe?.edges[0]?.node?.featuredImage?.node?.gatsbyImage ?? '',
    slug:  data?.recipe?.edges[0]?.node?.slug ?? '',
    title: data?.recipe?.edges[0]?.node?.title ?? '',
  };


  const featuredRecipeImage = getImage(featured.image)

  return (
    <nav className={`bg-dorot-purple topbar relative z-[60] h-[55px] md:h-[100px] transition-[top] duration-100 ease-in-out no-print ${scrolled ? 'shadow-dorot_button !sticky top-0': ''}`}>
      <div className="relative">
      <div className={"flex justify-between items-center py-3 px-7.5 w-full lg:px-18 relative " + (isExpanded ? "drop-shadow-[0_3px_6px_rgba(0,0,0,0.22)] z-[100]" : "")}>
        <div onClick={toggleMenu} className="1024:hidden">
          { isExpanded ?

            (
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" className="border border-solid  border-white rounded-full">
                <defs>
                  <clipPath id="clip-path">
                    <rect id="Frame_1_Background_Mask_" data-name="Frame 1 (Background/Mask)" width="30" height="30" fill="none"/>
                  </clipPath>
                </defs>
                <g id="Frame_1" data-name="Frame 1" clipPath="url(#clip-path)">
                  <g id="Group_934" data-name="Group 934" transform="translate(5.121 7.61)">
                    <path id="Line_1" data-name="Line 1" d="M.05,0H19.545" transform="translate(2.835 -0.035) rotate(45)" fill="none" stroke="#fff" strokeLinecap="round" strokeWidth="2" strokeDasharray="0 0"/>
                    <path id="Line_3" data-name="Line 3" d="M.05,0H19.545" transform="translate(2.835 13.819) rotate(-45)" fill="none" stroke="#fff" strokeLinecap="round" strokeWidth="2" strokeDasharray="0 0"/>
                  </g>
                </g>
              </svg>
            ) 
          :
            (
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                <defs>
                  <clipPath id="clip-path">
                    <rect id="Frame_1_Background_Mask_" data-name="Frame 1 (Background/Mask)" width="30" height="30" fill="none"/>
                  </clipPath>
                </defs>
                <g id="Frame_1" data-name="Frame 1" transform="translate(15 3)">
                  <g id="Frame_1-2" data-name="Frame 1" transform="translate(-15 -3)" clipPath="url(#clip-path)">
                    <g id="Group_934" data-name="Group 934" transform="translate(5.121 7.61)">
                      <path id="Line_1" data-name="Line 1" d="M.05,0H19.545" transform="translate(-0.035)" fill="none" stroke="#fff" strokeLinecap="round" strokeWidth="2" strokeDasharray="0 0"/>
                      <path id="Line_2" data-name="Line 2" d="M.038,0H19.43" transform="translate(-0.038 7.357)" fill="none" stroke="#fff" strokeLinecap="round" strokeWidth="2" strokeDasharray="0 0"/>
                      <path id="Line_3" data-name="Line 3" d="M.05,0H19.545" transform="translate(-0.035 14.713)" fill="none" stroke="#fff" strokeLinecap="round" strokeWidth="2" strokeDasharray="0 0"/>
                    </g>
                  </g>
                </g>
              </svg>
            )
          
          
          }

        </div>

        <div className="w-[55px] h-7.5 md:w-[114px] md:h-[63px]">
          <Link to="/" className="py-[19px]">
            <StaticImage
              src="../images/Dorot_Logo_White.png"
              className="image-contain"
              alt="Dorot Gardens"
            />
          </Link>
        </div>

        <div className="flex lg:flex-row items-center lg:justify-end lg:place-items-center lg:gap-x-22 xl:gap-x-20 2xl:gap-x-40 3xl:gap-x-80 4xl:gap-x-[40rem]">
          <div className="hidden 1024:block md:mr-6">
            <ul className="flex md:gap-x-[46px] lg:gap-x-9">
              <li>
                <a href="/products" className="text-white text-_1625 font-goldplay font-semibold">Products</a>
              </li>
              <li>
                <a href="/recipes" className="text-white text-_1625 font-goldplay font-semibold">Recipes</a>
              </li>
              <li>
                <a href="/cooking-classes" className="text-white text-_1625 font-goldplay font-semibold">Cooking Classes</a>
              </li>
              <li>
                <a href="/blog" className="text-white text-_1625 font-goldplay font-semibold">Blog</a>
              </li>
              <li>
                <a href="/about-us" className="text-white text-_1625 font-goldplay font-semibold">About Dorot Gardens</a>
              </li>
              {/* <li>
                <a href="https://www.wiltinsurance.com/" target="_blank" className="text-white text-_1625 font-goldplay">Wilt Insurance</a>
              </li> */}
            </ul>
          </div>

          <div className="flex lg:items-center lg:gap-12.5">
            <SearchBox />
          </div>
        </div>
      </div>
      
      { isExpanded &&
        (
        <div className="absolute z-50 bottom-2.5 top-[55px] md:top-[100px] inset-x-0">
          <div className="w-[82%] h-[98vh] bg-flavour-1 px-2.5 pt-9">

            <ul className="flex flex-col space-y-3">
              <MenuItem title='Products' link='/products' />

              <MenuItem title='Recipes' link='/recipes' />

              <MenuItem title='Cooking Classes' link='/cooking-classes' />

              <MenuItem title='Blog' link='/blog' />
              
              <MenuItem title='About Dorot Gardens' link='/about-us' />

              <MenuItem title='Wilt Insurance' link='https://www.wiltinsurance.com' />
            </ul>

            <div className="relative isolate h-[310px] w-[275px] mt-[112px] rounded-[10px] pt-7.5 pl-5 pb-11 mr-4.5 featured-recipe flex flex-col gap-y-6">

              <GatsbyImage image={featuredRecipeImage} alt="featured recipe" style={{position:"absolute"}} className="inset-0 w-full h-full rounded-[10px] z-[-1]" />

              <h2 className="text-_1625 font-goldplay text-white">Featured Recipe</h2>

              <h4 className="font-gelica text-_2025 text-white pr-[85px]">{featured.title}</h4>

              <Link to={`/project/${featured.slug}`} className="text-white text-_1625 font-goldplay underline inline-block mt-auto">Click here for the recipe</Link>

            </div>

          </div>
        </div>
        )
      }
      </div>
    </nav>
  )
}

export default Header
